import { Chess } from "@chesshotel/chess";
import { ChessTermType, TermAction, } from "@chesshotel/types";
import { uci2move } from "./util.js";
const mateInOneWitnessCache = new Map();
const MATE_IN_ONE_CACHE_CAP = 5000;
function getMateInOneWitness(fen) {
    const cached = mateInOneWitnessCache.get(fen);
    if (cached !== undefined)
        return cached;
    const chess = new Chess(fen);
    const moves = chess.uciMoves({ legal: true });
    for (const move of moves) {
        chess.move(move);
        if (!chess.inCheck()) {
            chess.undo();
            continue;
        }
        if (chess.isCheckmate()) {
            if (mateInOneWitnessCache.size > MATE_IN_ONE_CACHE_CAP) {
                mateInOneWitnessCache.clear();
            }
            mateInOneWitnessCache.set(fen, move);
            return move;
        }
        chess.undo();
    }
    if (mateInOneWitnessCache.size > MATE_IN_ONE_CACHE_CAP) {
        mateInOneWitnessCache.clear();
    }
    mateInOneWitnessCache.set(fen, null);
    return null;
}
function mateThreatWitness(fen) {
    const chess = new Chess(fen);
    if (!chess.inCheck()) {
        chess.changeTurn();
        const witnessMate = getMateInOneWitness(chess.fen());
        return { threatened: !!witnessMate, witnessMate: witnessMate ?? undefined };
    }
    else {
        return { threatened: false };
    }
}
function detectDefendMate(fen, moveStr) {
    const threat = mateThreatWitness(fen);
    if (!threat.threatened)
        return null;
    const chess = new Chess(fen);
    const played = chess.move(moveStr);
    const witnessAfterOurMove = getMateInOneWitness(chess.fen());
    if (witnessAfterOurMove)
        return null;
    const arrow = threat.witnessMate ? [uci2move(threat.witnessMate)] : [];
    if (chess.inCheck()) {
        return {
            term: ChessTermType.DEFEND_MATE_CHECK,
            termAction: TermAction.PERFORM,
            move: played,
            arrows: arrow,
        };
    }
    return {
        term: ChessTermType.DEFEND_MATE,
        termAction: TermAction.PERFORM,
        move: played,
        arrows: arrow,
    };
}
export function detectDefendMatePositive(position, lastPosition) {
    const defendMate = detectDefendMate(lastPosition.fen, position.move);
    if (defendMate) {
        return {
            ...defendMate,
            termAction: TermAction.PERFORM,
            maxGain: 10,
        };
    }
}
export async function detectDefendMateNegative(position, lastPosition) {
    const user = detectDefendMate(lastPosition.fen, position.move);
    const best = detectDefendMate(lastPosition.fen, lastPosition.bestMove);
    if (user && best) {
        const arrows = [...best.arrows, uci2move(lastPosition.bestMove)];
        return {
            ...best,
            term: ChessTermType.DEFEND_MATE,
            termAction: TermAction.BETTER_WAY,
            arrows,
            maxGain: 10,
        };
    }
    if (!user && best) {
        return {
            ...best,
            term: ChessTermType.DEFEND_MATE,
            termAction: TermAction.MISS,
            maxGain: 10,
        };
    }
}
//# sourceMappingURL=defendMate.js.map